var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardBooster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "christmas fireworks 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0833 6.1582L7.44333 10.7982L6.58573 9.94058L5.80493 9.15978L5.79853 9.15338L5.46573 8.81418C5.28013 8.63498 5.17773 8.39179 5.17773 8.12938C5.17773 7.98858 5.20973 7.84778 5.26733 7.72618C5.31213 7.61738 5.38253 7.52139 5.46573 7.43819L6.00973 6.89418L7.07213 5.8318L7.92333 4.9806L9.49133 3.4126C10.3297 4.5198 11.1809 5.4222 12.0833 6.1582Z",
    fill: "#F1DF9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5366 5.84496C10.5046 6.08816 10.2998 6.26096 10.063 6.26096C10.0438 6.26096 10.0182 6.25456 9.99262 6.25456L7.07422 5.83216L7.92542 4.98096L10.1334 5.30096C10.3958 5.33936 10.575 5.58256 10.5366 5.84496Z",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56196 8.08493C9.51716 8.31533 9.31876 8.47533 9.09476 8.47533C9.06276 8.47533 9.03076 8.46893 8.99876 8.46253L5.26758 7.72653C5.31238 7.61773 5.38278 7.52173 5.46598 7.43853L6.00998 6.89453L9.18436 7.52173C9.44676 7.57293 9.61316 7.82253 9.56196 8.08493Z",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58742 9.94096C6.56822 9.98576 6.54262 10.0306 6.51062 10.069C6.26742 10.4082 5.74262 10.7986 4.62902 10.7026C3.14422 10.5874 2.79862 11.1122 2.59382 11.4258C2.50422 11.573 2.35062 11.6498 2.19062 11.6498C2.10102 11.6498 2.01142 11.6242 1.93462 11.573C1.71062 11.4258 1.64662 11.1314 1.78742 10.9074C2.18422 10.293 2.87542 9.60176 4.71222 9.74256C5.21782 9.79376 5.58902 9.70416 5.73622 9.51216C5.82582 9.39056 5.81942 9.23056 5.80662 9.16016L6.58742 9.94096Z",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38234 8.42853C3.11738 8.42853 2.90234 8.21349 2.90234 7.94853C2.90234 7.68357 3.11738 7.46533 3.38234 7.46533C3.6473 7.46533 3.86234 7.67717 3.86234 7.94213V7.94853C3.86234 8.21349 3.6473 8.42853 3.38234 8.42853Z",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2857 2.51048L13.9977 6.36968C13.9849 6.60006 13.8569 6.79206 13.6585 6.88166C13.5753 6.92646 13.4793 6.94566 13.3769 6.94566C13.2361 6.94566 13.0889 6.90086 12.9609 6.81766C12.9289 6.79206 12.8905 6.77286 12.8585 6.74086L5.83127 13.7681C5.73527 13.8641 5.61367 13.9089 5.49207 13.9089C5.37047 13.9089 5.24887 13.8641 5.15287 13.7681C4.96727 13.5825 4.96727 13.2753 5.15287 13.0897L12.0841 6.15848C11.1817 5.42248 10.3305 4.52008 9.49209 3.41288C9.42809 3.32968 9.37049 3.24648 9.30649 3.16328C9.14649 2.92648 9.11449 2.66408 9.22329 2.45288C9.31289 2.25448 9.51129 2.13288 9.74169 2.11368L13.6009 1.82568H13.6521C13.8185 1.82568 13.9849 1.88968 14.1001 2.01128C14.2345 2.14568 14.2985 2.32488 14.2857 2.51048Z",
    fill: "#00C087"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardBooster);
export default __webpack_public_path__ + "static/media/reward-booster.8c4ef0d7dc0de7e28bf4859e14052b01.svg";
export { ForwardRef as ReactComponent };